// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__30_nZ","checkboxCol":"Table_checkboxCol__1R2hr","emailCol":"Table_emailCol__15Ib1","actionCol":"Table_actionCol__2oSI0"};